import { render, staticRenderFns } from "./CryptoAccountsTab.vue?vue&type=template&id=7c7ff550"
import script from "./CryptoAccountsTab.vue?vue&type=script&lang=js"
export * from "./CryptoAccountsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports